import { JumpToStrip } from '@components/UI-Components/JumpToStrip'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import styled from 'styled-components'
import { LETTERWIDTH, STRIPCONTAINERHEIGHT, STRIPHEIGHT } from '../common'
import { TableViewStoreContext } from '../container/StandardTableView'

export interface ILetterJumpToProps {
  data: Array<string>
  stripWidth?: number
}

const StyledContainer = styled.div<{ width: number }>`
  height: ${STRIPCONTAINERHEIGHT + 'px'};
  width: ${props => props.width + 'px'};
  padding: 20px 0px 15px 0px;
`

export const LetterJumpTo: React.FunctionComponent<ILetterJumpToProps> = ({
  data,
  stripWidth
}) => {
  return useObserver(function useHook() {
    const { onLetterSelect, letterToHighlight } = React.useContext(
      TableViewStoreContext
    ) as any

    return (
      <StyledContainer width={stripWidth as number}>
        <JumpToStrip
          dataWidth={LETTERWIDTH}
          stripData={data}
          dataToHighlight={letterToHighlight}
          onDataSelect={onLetterSelect}
          height={STRIPHEIGHT}
        ></JumpToStrip>
      </StyledContainer>
    )
  })
}
